import React from 'react';
import classNames from 'classnames';

import { OrderBlockWrapper } from '../../../Common/OrderBlockWrapper';

import { Props } from './types';

import styles from './ContractDetailsWrapper.module.scss';

export const ContractDetailsWrapper = ({
  classes,
  title,
  children,
  tabletView,
}: Props): JSX.Element => {
  return (
    <OrderBlockWrapper
      className={classNames(
        styles.wrapper,
        { [styles.hasTabletView]: tabletView },
        classes?.container,
      )}
    >
      <section className={classNames(styles.description, classes?.title)}>
        <section className={styles.title}>{title}</section>
      </section>
      <section className={classNames(styles.action, classes?.actions)}>{children}</section>
    </OrderBlockWrapper>
  );
};
